import { useSelector } from 'react-redux'

/**
 * Hook to return authorization flags
 */
const useAuthorization = () => {
  const selectedCustomer = useSelector(({ customers }) => customers?.selectedCustomer)

  // org subscriptions
  const hasEngageAutopilotSubscription = useSelector(({ meta }) => meta.hasEngageAutopilotSubscription)

  // nfr licenses
  const hasNfrEngageEssentialsLicense = selectedCustomer?.hasNfrEngageEssentialsLicense

  // feature flags
  const isEngageAutopilotEnabled = useSelector(
    ({ featureFlags }) => featureFlags?.data?.find((item) => item.feature === 'engage-autopilot')?.enabled,
  )

  return {
    isAuthorizedForEngageAutopilot:
      isEngageAutopilotEnabled && (hasEngageAutopilotSubscription || hasNfrEngageEssentialsLicense),
  }
}

export default useAuthorization
